import { useEffect, useState } from "react";
import Papa from "papaparse";
import Stack from "@/components/ui/stack";
import Hstack from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import { SheetData } from "@/types/question";
import clsx from "clsx";

export default function CsvTableViewer({
  sheetData,
}: {
  sheetData: SheetData[] | [];
}) {
  const [data, setData] = useState<string[][]>([]);
  const [_csvString, _setCsvString] = useState<string>("");
  const [index, setIndex] = useState<number>(0);

  useEffect(() => {
    if (sheetData.length > 0 && index < sheetData.length) {
      _setCsvString(sheetData[index].data);
    }
  }, [sheetData, index]);

  useEffect(() => {
    if (!_csvString) return;
    const parsed = Papa.parse(_csvString.trim(), { skipEmptyLines: false });
    const rows = parsed.data as string[][];
    if (!Array.isArray(rows) || rows.length === 0) {
      setData([]);
      return;
    }
    const maxCols = Math.max(...rows.map((r) => r.length));
    const normalized = rows.map((r) => {
      const diff = maxCols - r.length;
      return diff > 0 ? [...r, ...Array(diff).fill("")] : r;
    });

    setData(normalized);
  }, [_csvString]);

  // if (!data.length)
  //   return <p className="p-4 text-gray-500 text-center">No data</p>;

  return (
    <Stack className="py-4">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-400 border-collapse">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              {data?.[0]?.map((header, idx) => (
                <th
                  key={idx}
                  className="border border-gray-400 px-3 py-2 text-sm font-semibold text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.slice(1).map((row, rowIdx) => (
              <tr
                key={rowIdx}
                className={rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                {row.map((cell, colIdx) => (
                  <td
                    key={colIdx}
                    className="border border-gray-400 px-3 py-2 text-sm text-gray-800"
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Hstack>
        {sheetData.length > 0 &&
          sheetData.map((item, _index) => {
            return (
              <Button
                key={`${item.tab_name} + ${_index}`}
                className={clsx(
                  "p-2 m-2 border border-black",
                  index === _index
                    ? "bg-[#0B2B57] hover:bg-[#0B2B57] text-white"
                    : "bg-white hover:bg-white text-black"
                )}
                onClick={() => {
                  setIndex(_index);
                }}
              >
                {item.tab_name}
              </Button>
            );
          })}
      </Hstack>
    </Stack>
  );
}
